export default (indexable) => (indexable ? {} : { rel: 'nofollow' });
